<template>
  <div class="mobile-box container lib__no-padding row">
    <div :class="'col-xs-12 col-sm-12 col-md-12 col-lg-12 lib__no-margin lib__no-padding'">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 row mobile-box top-text-container">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mobile-box title lib__text-ellipsis">
          {{ title }}
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 row mobile-box bottom-text-container">
      <div v-if="description" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mobile-box readonly description-margin">
          {{ description }}
      </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  name: 'readonly-mobile-box'
})
export default class ReadonlyMobileBox extends Vue {
  @Prop({ type: String, required: true }) public title!: string
  @Prop({ type: String, required: true }) public description!: string
}
</script>

<style scoped>
.mobile-box.container {
  box-sizing: border-box;
  border: 1px solid #C1C7CC;
  border-radius: 4px;
  margin: 20px auto;
}

@media screen and (min-width: 577px) {
  .mobile-box.title {
    height: 40px;
    width: 200px;
    color: #1A262F;
    font-family: "Open Sans";
    font-size: 18px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 18px;
  }
  .mobile-box.top-text-container {
    margin: 10px 0px 0px;
  }
  
  .mobile-box.bottom-text-container {
    margin: 0px 0px 10px;
  }
  .mobile-box.description {
    height: 18px;
    width: 260px;
    color: #1A262F;
    font-family: "Open Sans";
    font-size: 14px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 18px;
  }
}

@media screen and (max-width: 576px) {
  .mobile-box.container {
    width: 100%;
  }
  .mobile-box.title {
    width: 1em;
    color: #1A262F;
    font-family: "Open Sans";
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 18px;
  }
  .mobile-box.top-text-container {
    margin: 20px 0px 0px;
  }
  
  .mobile-box.bottom-text-container {
    margin: 10px 0px 0px;
  }
  .mobile-box.description {
    height: 18px;
    width: 260px;
    color: #1A262F;
    font-family: "Open Sans";
    font-size: 12px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 18px;
  }
  .mobile-box.button-container {
    margin: 10px 0px 10px;
    text-align: center;
    font-size: 14px;
    letter-spacing: 0;
    line-height: 20px;
  }
  .mobile-box.readonly.description-margin {
    margin-bottom: 20px;
  }
}
</style>
